import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { Toaster } from "react-hot-toast";
import { store } from "./redux/store";
import "./style.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
    <React.StrictMode>
      <Toaster position="top-right" reverseOrder={false} />
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
);
